import React from 'react';
import PropTypes from 'prop-types';

export const ArrowLeft = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-left'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z'
    />
  </svg>
);

ArrowLeft.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowLeft.defaultProps = {
  width: 24,
  height: 24,
};
